import { useEffect } from 'react';
import { makeSelectors } from '@utils/css';

const activeLocks = {
  expand: 0,
  collapse: 0
};
const forcedHeaderStateSelectors = makeSelectors({
  expanded: "header--expanded-force",
  collapsed: "header--collapsed-force"
});
function useForceHeaderExpanded(enabled) {
  useEffect(() => {
    if (enabled) {
      onLockStateChanged(forcedHeaderStateSelectors.expanded.className, ++activeLocks.expand);
    }
    return () => {
      if (enabled) {
        onLockStateChanged(forcedHeaderStateSelectors.expanded.className, --activeLocks.expand);
      }
    };
  }, [enabled]);
}
function useForceHeaderCollapsed(enabled) {
  useEffect(() => {
    if (enabled) {
      onLockStateChanged(forcedHeaderStateSelectors.collapsed.className, ++activeLocks.collapse);
    }
    return () => {
      if (enabled) {
        onLockStateChanged(forcedHeaderStateSelectors.collapsed.className, --activeLocks.collapse);
      }
    };
  }, [enabled]);
}
function onLockStateChanged(selector, lockCount) {
  document.documentElement.classList.toggle(selector, lockCount > 0);
}

export { forcedHeaderStateSelectors, useForceHeaderCollapsed, useForceHeaderExpanded };
//# sourceMappingURL=useForceHeaderState.js.map
